import {returntypeof} from 'react-redux-typescript';
import {createSelector} from 'reselect';
import React from 'react';
import {Dispatch, compose} from 'redux';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import Helloworld from 'components/helloworld/index';
import {changeLocale} from 'containers/LanguageProvider/actions';
import {makeSelectLocale} from 'containers/LanguageProvider/selectors';
import {appLocales} from 'i18n';
import {changeTheme} from 'containers/ThemeProvider/actions';
import {makeSelectThemeName} from 'containers/ThemeProvider/selectors';
import {appThemes, withStyles, css} from 'withStyles';
import {loadPicdata} from 'containers/HomePage/actions';
import {IWithStyleProps} from '../../Interfaces/react-with-style';
import reducer from './reducer';
import saga from './saga';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import {makeSelectPicdata} from 'containers/HomePage/selectors';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Drawer from 'material-ui/Drawer';
import SelectField from 'material-ui/SelectField';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';
import PictureList from 'components/PictureList';
import {PictureCard} from 'components/PictureCard';
import 'file-loader?name=data.json!../../data.json';
import RaisedButton from 'material-ui/RaisedButton';
import saveExcel from 'containers/HomePage/saveExcel';

interface IHomePageProps {
}

interface IHomePageState {
  drawerOpen?: boolean;
  Category?: string;
  level?: string;
  listDisplay?: boolean;
}

const mapStateToProps = createSelector(
  makeSelectLocale(),
  makeSelectThemeName(),
  makeSelectPicdata(),
  (locale, theme, picdate) => ({locale, theme, picdate})
);

export const mapDispatchToProps = (dispatch: Dispatch<{}>) => ({
  changeLocale: (locale: string) => dispatch(changeLocale(locale)),
  changeTheme: (theme: string) => dispatch(changeTheme(theme))
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & IHomePageProps & typeof dispatchProps & IWithStyleProps;
type State = IHomePageState;

@withStyles(({}) => ({
  main: {
    'max-width': '900px',
    'margin': '0px auto',
    'padding': '0px 20px'
  },
  form: {
    margin: '20px 0px'
  },
  formItem: {
    'margin-left': '20px',
    'margin-right': '20px'
  },
  Button: {
    'min-width': '105px',
    'margin-left': '20px',
    'margin-right': '20px'
  },
  Toggle: {
    width: '256px',
    margin: '20px 20px'
  },
  line: {
    'display': 'flex',
    'align-items': 'center',
    'flex-wrap': 'wrap'
  },
  fullline: {
    'flex-grow': '1'
  }
}))
export class HomePage extends React.PureComponent<Props, State> {
  constructor() {
    super();
    this.state = {
      drawerOpen: true,
      Category: 'All',
      level: 'All',
      listDisplay: false
    };
  }

  handleCategoryChange = (event: any, key: number, payload: any) => {
    this.setState({
      ...this.state,
      Category: payload
    });
  }

  handleExportButton = () => {
    saveExcel(this.props.picdate);
  }

  getCategories() {
    if (this.props.picdate) {
      const CategoriesList: string[] = [];
      this.props.picdate.forEach((value) => {
        if (!CategoriesList.includes(value.分类)) {
          CategoriesList.push(value.分类);
        }
      });
      return CategoriesList;
    }
    return [];
  }

  getMenuItem = () => {
    const c = this.getCategories();
    const MenuItems: React.ReactNode[] = [];
    MenuItems.push(
      <MenuItem key={'All'} value={'All'} primaryText={'全部'} />
    );
    c.forEach((value) => {
      MenuItems.push(
        <MenuItem key={value} value={value} primaryText={value} />
      );
    });
    return MenuItems;
  }

  handleLevelChange = (event: any, key: number, payload: any) => {
    this.setState({
      ...this.state,
      level: payload
    });
  }

  getLevel = () => {
    if (this.props.picdate) {
      const Levels: string[] = [];
      this.props.picdate.forEach((value) => {
        let 奖项等第 = value.奖项等第;
        if (typeof 奖项等第 === 'undefined') {
          奖项等第 = '无等第';
        }
        if (!Levels.includes(奖项等第)) {
          Levels.push(奖项等第);
        }
      });
      return Levels;
    }
    return [];
  }

  getLevelItem = () => {
    const c = this.getLevel();
    const a = c.map((value) => <MenuItem key={value} value={value} primaryText={value} />);
    a.push(<MenuItem key={'All'} value={'All'} primaryText={'全部'} />);
    return a;
  }

  getList = (Category: string, Level: string) => {
    if (this.props.picdate) {
      const List: React.ReactNode[] = [];
      this.props.picdate.forEach((value, index) => {
        if (Category === 'All' || value.分类 === Category) {
          if (Level === 'All' || value.奖项等第 === Level || (typeof value.奖项等第 === 'undefined' && Level === '无等第')) {
            List.push(<PictureList key={index} picdate={value} />);
          }
        }
      });
      return List;
    }
    return [];
  }

  getCards(Category: string, Level: string) {
    if (this.props.picdate) {
      const Cards: React.ReactNode[] = [];
      this.props.picdate.forEach((value, index) => {
        if (Category === 'All' || value.分类 === Category) {
          if (Level === 'All' || value.奖项等第 === Level || (typeof value.奖项等第 === 'undefined' && Level === '无等第')) {
            Cards.push(
              <PictureCard
                key={index}
                date={value}
                onClickFlatButton={() => {
                  this.setState({
                    ...this.state,
                    Category: value.分类
                  });
                }}
              />
            );
          }
        }
      });
      return Cards;
    }
    return [];
  }

  public render() {
    const Theme = getMuiTheme({
      fontFamily: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", ' +
      'Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif'
    });
    return (
      <MuiThemeProvider muiTheme={Theme}>
        <div
          style={{
            fontFamily: Theme.fontFamily
          }}
        >
          <main {...css(this.props.styles.main)}>
            <div {...css(this.props.styles.form)}>
              <div {...css(this.props.styles.line)}>
                <SelectField
                  floatingLabelText='分类'
                  value={this.state.Category}
                  onChange={this.handleCategoryChange}
                  {...css(this.props.styles.formItem)}
                >
                  {
                    this.getMenuItem()
                  }
                </SelectField>
                <SelectField
                  floatingLabelText='奖项等级'
                  value={this.state.level}
                  onChange={this.handleLevelChange}
                  {...css(this.props.styles.formItem)}
                >
                  {
                    this.getLevelItem()
                  }
                </SelectField>
                <div {...css(this.props.styles.fullline)}/>
                <RaisedButton
                  label='导出Excel'
                  primary
                  onClick={this.handleExportButton}
                  {...css(this.props.styles.Button)}
                />
              </div>
              <Toggle
                defaultToggled={this.state.listDisplay}
                label='列表显示'
                {...css(this.props.styles.Toggle)}
                onToggle={
                  (event: any, isInputChecked: boolean) => {
                    this.setState({
                      ...this.state,
                      listDisplay: isInputChecked
                    });
                  }
                }
              />
            </div>
            {
              this.state.listDisplay ?
                this.getList(this.state.Category, this.state.level) :
                this.getCards(this.state.Category, this.state.level)
            }
          </main>
        </div>
      </MuiThemeProvider>
    );
  }
}

// tslint:disable-next-line:max-line-length
const withConnect = connect<typeof stateProps, typeof dispatchProps, IHomePageProps>(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({key: 'home', reducer});
const withSaga = injectSaga({key: 'home', saga});

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.tsx